import * as React from 'react'

const PURPLE = '#7D66FF'

interface DebinProps {
  color?: string
}

function Debin({ color = PURPLE }: DebinProps) {
  return (
    <svg width={30} height={30} viewBox="0 0 25 24" fill="none">
      <path
        d="M11.6677 7.09082V8.3757"
        stroke={color}
        strokeWidth={1.43249}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6677 14.7988V16.0837"
        stroke={color}
        strokeWidth={1.43249}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        // eslint-disable-next-line max-len
        d="M9.74031 14.7994H12.6312C13.0571 14.7994 13.4656 14.6302 13.7668 14.329C14.068 14.0278 14.2372 13.6193 14.2372 13.1933C14.2372 12.7673 14.068 12.3588 13.7668 12.0576C13.4656 11.7564 13.0571 11.5872 12.6312 11.5872H10.7039C10.278 11.5872 9.86949 11.418 9.5683 11.1168C9.26711 10.8156 9.0979 10.4071 9.0979 9.9811C9.0979 9.55514 9.26711 9.14662 9.5683 8.84542C9.86949 8.54421 10.278 8.375 10.7039 8.375H13.5948"
        stroke={color}
        strokeWidth={1.43249}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        // eslint-disable-next-line max-len
        d="M12.4253 1.40625C14.7652 1.43757 17.0306 2.23394 18.8745 3.6748C20.5069 4.95039 21.7292 6.66875 22.4019 8.61621C22.5466 9.0354 22.2877 9.47589 21.8589 9.58887C21.4301 9.70173 20.9946 9.44445 20.8442 9.02734C20.2647 7.41869 19.241 5.99987 17.8853 4.94043C16.318 3.71581 14.3926 3.03834 12.4038 3.01172C10.4148 2.98515 8.47115 3.61143 6.87158 4.79395C5.69682 5.66252 4.75514 6.79639 4.1167 8.09375L6.57764 7.16699C6.85511 7.0623 7.16518 7.20211 7.27002 7.47949C7.37436 7.75682 7.23466 8.06706 6.95752 8.17188L2.43408 9.87793C2.15666 9.9826 1.8466 9.84271 1.7417 9.56543L0.034668 5.04199C-0.0699991 4.76458 0.0699271 4.45452 0.347168 4.34961C0.624742 4.24488 0.934821 4.3855 1.03955 4.66309L2.34619 8.125C3.08283 6.28916 4.31596 4.6859 5.91748 3.50195C7.7993 2.11084 10.0854 1.375 12.4253 1.40625Z"
        fill={color}
      />
      <path
        // eslint-disable-next-line max-len
        d="M11.5764 22.5928C9.23657 22.5614 6.97111 21.7651 5.1272 20.3242C3.4948 19.0486 2.27252 17.3303 1.59985 15.3828C1.45507 14.9636 1.71396 14.5231 2.14282 14.4102C2.57158 14.2972 3.00707 14.5546 3.15747 14.9717C3.73701 16.5803 4.76066 17.9992 6.11646 19.0586C7.68374 20.2832 9.60911 20.9607 11.5979 20.9873C13.5869 21.0139 15.5306 20.3876 17.1301 19.2051C18.3052 18.3363 19.2466 17.202 19.885 15.9043L17.4231 16.832C17.1456 16.9367 16.8355 16.797 16.7307 16.5195C16.6264 16.2422 16.7661 15.932 17.0432 15.8271L21.5667 14.1211C21.8442 14.0164 22.1543 14.157 22.259 14.4346L23.9661 18.957C24.0707 19.2344 23.9308 19.5445 23.6536 19.6494C23.376 19.7541 23.0659 19.6135 22.9612 19.3359L21.6555 15.876C20.9188 17.7111 19.6853 19.3135 18.0842 20.4971C16.2024 21.8882 13.9163 22.624 11.5764 22.5928Z"
        fill={color}
      />
    </svg>
  )
}

Debin.defaultProps = {
  color: PURPLE
}

export default Debin
